export default __webpack_public_path__ + "static/media/group-in-numbers.5b8bda09.jpeg";